import { Plus } from 'lucide-react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '@/components/primitives/Button.jsx';
import { assistantThreadItems } from '@/redux/selectors/pieveSelectors/assistantSelectors.js';
import ThreadListItem from './ThreadListItem.jsx';

/** Beside an open conversation on wide screens: a new request and the other conversations, to switch without going home. */
const ThreadRail = () => {
  const navigate = useNavigate();
  const items = useSelector(assistantThreadItems);

  return (
    <nav className="assistant-rail" aria-label="Conversations">
      <Button variant="secondary" iconStart={Plus} onClick={() => navigate('/')}>
        New request
      </Button>
      <ul className="assistant-rail__list">
        {items.map((item) => (
          <ThreadListItem key={item.id} item={item} />
        ))}
      </ul>
    </nav>
  );
};

export default ThreadRail;
